import { atom, selector } from 'recoil';

import { annualDfiReportYearState } from 'store';

export const dfiReportBestPracticeResponseIsEditingState = atom<boolean>({
  key: 'dfiReportBestPracticeResponseIsEditing',
  default: false,
});

export const dfiReportInfoOnLateResponseIsEditingState = atom<boolean>({
  key: 'dfiReportInfoOnLateResponseIsEditing',
  default: false,
});

export const dfiReportInfoOnLateResponseState = atom<string>({
  key: 'dfiReportInfoOnLateResponse',
  default: '',
});

export const tqEnReportInfoOnLateResponseState = atom<string>({
  key: 'tqEnReportInfoOnLateResponse',
  default: '',
});

export const dfiReportBestPracticeResponseState = atom<string>({
  key: 'dfiReportBestPracticeResponse',
  default: '',
});

export const tqEnReportBestPracticeResponseState = atom<string>({
  key: 'tqEnReportBestPracticeResponse',
  default: '',
});

export const dfiReportIsEditingState = selector<boolean>({
  key: 'dfiReportIsEditing',
  get: ({ get }) =>
    get(dfiReportInfoOnLateResponseIsEditingState) ||
    get(dfiReportBestPracticeResponseIsEditingState),
});

export const dfiReportUpdateValuesState = selector({
  key: 'dfiReportUpdateValues',
  get: ({ get }) => {
    return {
      reportYear: get(annualDfiReportYearState),
      infoOnLateResponse: get(dfiReportInfoOnLateResponseState),
      bestPracticeResponse: get(dfiReportBestPracticeResponseState),
    };
  },
});
